// Custom HECHTER PARIS: Hover-Groessenleiste auf Produktkacheln (Quick Buy)
// Klick auf eine Groesse setzt die Variante im Quick-Add-Formular und submittet es.
// Der bestehende product-form-component uebernimmt den AJAX-Add und oeffnet den Cart-Drawer.
if (!window.__hpQuickBuySizesInit) {
  window.__hpQuickBuySizesInit = true;
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-hp-size-variant]') : null;
    if (!target || target.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    const form = target.closest('form');
    if (!form) return;
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    variantInput.disabled = false;
    variantInput.value = target.dataset.hpSizeVariant;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
}
